import React from 'react';
import { Border, Box, Flex, Subhead as Title } from 'rebass';
import Logo from './logo';

export default function Header({ name, subHeading, children }) {
  return (
    <Flex align="center" wrap>
      <Box w={[1, 1 / 15]} mr={[0, 'auto']}>
        <Logo style={{ color: 'white' }} />
      </Box>
      <Box is="header" m="auto" w={[1, 1 / 2]}>
        <Border top bottom py={2} my={2}>
          <Title
            children={`Welcome to the Supplier Brand Directory${
              name === undefined ? '' : `, ${name}`
            }`}
          />
          {subHeading}
        </Border>
      </Box>
      {evenlyDistribute(children)}
    </Flex>
  );
}

function evenlyDistribute(children, proportion = 1 / 4) {
  const width = proportion / React.Children.count(children);
  return React.Children.map(children, child => (
    <Box w={[1, width]}>{child}</Box>
  ));
}



// WEBPACK FOOTER //
// ./src/Header/index.js